export default "/048cb1f2b29308e18768c65cfd51e426596a830c/dfffdcc654f425d556d7485c2bf841db.svg";